import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store';
// import HelloWorld from '@/components/HelloWorld'

import PageElements 	from '@/components/Pages/PageElements'
import PagePlace 		from '@/components/Pages/PagePlace'
import PageRegister 	from '@/components/Pages/PageRegister'
import PageTime 		from '@/components/Pages/PageTime'
import PageRentaltypes 	from '@/components/Pages/PageRentaltypes'
import PageCar 			from '@/components/Pages/PageCar'
import PageVoucher 			from '@/components/Pages/PageVoucher'
import PageSummary 		from '@/components/Pages/PageSummary'
import PagePostident 		from '@/components/Pages/PagePostident'
import PageDetails 		from '@/components/Pages/PageDetails'
import PageHome 		from '@/components/Pages/PageHome'
import PageLogin	 	from '@/components/Pages/PageLogin'
import PageLoginResStep	 	from '@/components/Pages/PageLoginResStep'
import PageMycshare	 	from '@/components/Pages/PageMycshare'
import PageMybookings	from '@/components/Pages/PageMybookings'
import PageMydata		from '@/components/Pages/PageMydata'
import PageMybookingdetails	from '@/components/Pages/PageMybookingdetails'
import PageMyPayment		from '@/components/Pages/PageMyPayment'
import PageContact		from '@/components/Pages/PageContact'
import PageFaq			from '@/components/Pages/PageFaq'
import PageContent			from '@/components/Pages/PageContent'
import PageHomeGrav			from '@/components/Pages/PageHomeGrav'





import PageTest			from '@/components/Pages/PageTest'

import PageReservation 		from '@/components/Pages/PageReservation'


function SANITIZE_STATION(v){
	return false;
}
function SANITIZE_STARTDATE(v){
	return false;
}
function SANITIZE_ENDDATE(v){
	return false;
}
function SANITIZE_CARGROUP(v){
	return false;
}

Vue.use(Router);

let router = new Router({
	mode: 'history',
	routes: [
		{
		  path: '/',
		  name: 'PageHome',
		  component: PageHome
		},
		{
		  path: '/contact',
		  name: 'PageContact',
		  component: PageContact
		},
		{
		  path: '/faq',
		  name: 'PageFaq',
		  component: PageFaq
		},
		{
			path: '/test',
			name: 'PageTest',
			component: PageTest,
			children: [
				//
				//
				// /test/S/CS
				// /test/S/CS/station
				// /test/S/CS/ST/2019-09-20/
				// /test/S/CS/ST/2019-09-20/summary
				// /test/S/CS/ST/2019-09-20/ET/2019-09-20/
				// /test/S/CS/ST/2019-09-20/ET/2019-09-20/summary
				// /test/S/CS/ST/2019-09-20/ET/2019-09-20/CAR/F/
				// /test/S/CS/ST/2019-09-20/ET/2019-09-20/CAR/F/summary
				// /test/S/<station>/E/<endstation>/ST/<starttime>/ET/<endtime>/CAR/<car>/<view>
				//
				//
				{
					path: ':k/:v/',
					name: 'Step1',
					children: [
						{
							path: ':view',
							name: 'Step1View',
							component: PageTest,
						},
						{
							path: ':k2/:v2/',
							name: 'Step2',
							children: [
								{
									path: ':view',
									name: 'Step2View',
									component: PageTest,
								},
								{
									path: ':k3/:v3/',
									name: 'Step3',
									children: [
										{
											path: ':view',
											name: 'Step3View',
											component: PageTest,
										},
										{
											path: ':k4/:v4/',
											name: 'Step4',
											children: [
												{
													path: ':view',
													name: 'Step4View',
													component: PageTest,
												},
											]
										},
									]
								},
							]
						},
					]
				},
			]
		},





		{
		  path: '/mycshare/',
		  component: PageMycshare,
			meta: {
				requiresAuth: true
			},
			children: [
			  {
			  		path: '',
			  		name: 'PageMycshare',
			  		redirect: {
			  			name: 'PageMybookings',
			  		},
					meta: {
						requiresAuth: true
					}
			  	},
			  	{
			  		path: 'bookings',
			  		name: 'PageMybookings',
			  		component: PageMybookings,
					meta: {
						requiresAuth: true
					}
			  	},
			  	{
			  		path: 'bookings/details',
			  		name: 'PageMybookingdetails',
			  		component: PageMybookingdetails,
					meta: {
						requiresAuth: true
					}
			  	},
			  	{
			  		path: 'data',
			  		name: 'PageMydata',
			  		component: PageMydata,
					meta: {
						requiresAuth: true
					}
				  },
				  {
					path: 'payment',
					name: 'PageMyPayment',
					component: PageMyPayment,
				  meta: {
					  requiresAuth: true
				  }
				},
			]
		},
		{
		  path: '/elements',
		  name: 'PageElements',
		  component: PageElements
		},
		{
			path: '/homeGrav',
			name: 'PageHomeGrav',
			component: PageHomeGrav,

		},
		{
			path: '/reservation/',
			component: PageReservation,
			children: [
				{
					path: 'register',
					name: 'PageRegister',
					component: PageRegister
				},
				{
					// path: 'register/:v',
					path: 'ident',
					name: 'PagePostident',
					component: PagePostident,
					/* meta: {
						requiresAuth: true
					} */
				},
				
				{
					path: 'login',
					name: 'PageLogin',
					component: PageLogin,
					meta: {
						requiresPublic: true
					}
				},
				{
					path: '',
					name: 'PageLoginResStep',
					component: PageLoginResStep,
					meta: {
						requiresPublic: true
					}
				},
				{
					path: 'place',
					name: 'PagePlace',
					component: PagePlace,
					// meta: {
					// 	requiresAuth: true
					// }
				},
				{
			      path: 'place/:stationid',
			      name: 'PagePlace',
			      component: PagePlace,
			    },
				{
					path: 'time',
					name: 'PageTime',
					component: PageTime
				},
				{
			      path: 'time/:stationid',
			      name: 'PageTime',
			      component: PageTime,
				},
				{
					path: 'rentaltype',
					name: 'PageRentaltypes',
					component: PageRentaltypes,
					meta: {
						requiresAuth: true
					}
				},
				{
					path: 'car',
					name: 'PageCar',
					component: PageCar
				},
				{
					path: 'voucher',
					name: 'PageVoucher',
					component: PageVoucher
				},
				
				{
					path: 'summary',
					name: 'PageSummary',
					component: PageSummary,
					meta: {
						requiresAuth: true
					}
				},

				{
					path: 'details',
					name: 'PageDetails',
					component: PageDetails
				},

				{
			      path: ':stationid',
			      name: 'PagePlace',
			      component: PagePlace,
			    },
				
			]
		},
		{
	      path: '/:id',
	      name: 'Page',
	      component: PageContent,
		},
		
	]
});

router.beforeEach(async (to, from, next) => {
	if( await store.getters['orm/reservation/user_session']){
		await store.dispatch('orm/GET_CUSTOMER');
	}
	if(to.matched.some(record => record.meta.requiresAuth)) {

		if(!store.getters['orm/reservation/user_session']){
			next('/reservation/');
			return;
		}
		next();
		return;

	} else if(to.matched.some(record => record.meta.requiresPublic)) {
		if(!!store.getters['orm/reservation/user_session']){
			next('/mycshare/')
			return;
		}
		next()
	} else {
		next()
	}
});

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js